import React from "react";

export default function ViewModelCompany({ showViewModal, viewData, closeViewModal }) {
    if (!showViewModal || !viewData) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                zIndex: 999,
            }}
        >
            <div
                style={{
                    position: "fixed",
                    bottom: "-40%",
                    top: "55%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "750px",
                    background: "#fff",
                    borderRadius: "10px",
                    zIndex: 1000,
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* HEADER */}
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ padding: "16px 20px", borderBottom: "1px solid #ddd" }}
                >
                    <h5 className="mb-0">Company Details</h5>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={closeViewModal}
                    >
                        <i className="ti ti-x"></i>
                    </button>
                </div>

                {/* BODY */}
                {/* <div style={{ padding: "20px", overflowY: "auto" }}>
                    <div className="row">
                        <div className="col-md-6">
                            <Field label="Company Name" value={viewData.companyName} />
                            <Field label="Email" value={viewData.emailId} />
                            <Field label="Phone" value={viewData.phone} />
                            <Field label="State" value={viewData.stateName} />
                            <Field label="Status" value={viewData.status} />
                        </div>

                        <div className="col-md-6">
                            <Field label="Company Code" value={viewData.companyCode} />
                            <Field label="Mobile" value={viewData.mobileNo} />
                            <Field label="Country" value={viewData.countryName} />
                            <Field label="District" value={viewData.cityName} />

                        </div>
                    </div>

                    {/* FOOTER */}
                    {/* <div className="d-flex justify-content-end mt-2">
                        <button className="btn btn-secondary" onClick={closeViewModal}>
                            <i className="ti ti-cancel me-1"></i> Close
                        </button>
                    </div>
                </div> */}

                <div style={{ padding: "20px", overflowY: "auto" }}>
    <div className="row">

        {/* ROW 1 */}
        <div className="col-md-6">
            <Field label="Company Code" value={viewData.companyCode} />
        </div>
        <div className="col-md-6">
            <Field label="Company Name" value={viewData.companyName} />
        </div>

        {/* ROW 2 */}
        <div className="col-md-6">
            <Field label="Email" value={viewData.emailId} />
        </div>
        <div className="col-md-6">
            <Field label="Mobile" value={viewData.mobileNo} />
        </div>

        {/* ROW 3 */}
        <div className="col-md-6">
            <Field label="Phone" value={viewData.phone} />
        </div>
        <div className="col-md-6">
            <Field label="Fax" value={viewData.fax} />
        </div>

        {/* ROW 4 */}
        <div className="col-md-6">
            <Field label="Address" value={viewData.address} />
        </div>
        <div className="col-md-6">
            <Field label="Landmark" value={viewData.landMark} />
        </div>

        {/* ROW 5 */}
        <div className="col-md-6">
            <Field label="Website" value={viewData.website} />
        </div>
        <div className="col-md-6">
            <Field label="Logo Small URL" value={viewData.logoSmallURL} />
        </div>

        {/* ROW 6 */}
        <div className="col-md-6">
            <Field label="Logo Big URL" value={viewData.logoBigURL} />
        </div>
        <div className="col-md-6">
            <Field label="Country" value={viewData.countryName || viewData.countryId} />
        </div>

        {/* ROW 7 */}
        <div className="col-md-6">
            <Field label="State" value={viewData.stateName || viewData.state} />
        </div>
        <div className="col-md-6">
            <Field label="District" value={viewData.cityName || viewData.city} />
        </div>

        {/* ROW 8 */}
        <div className="col-md-6">
            <Field label="Zip Code" value={viewData.zip} />
        </div>
        <div className="col-md-6">
            <Field label="Establishment Year" value={viewData.estableshmentYear} />
        </div>

        {/* ROW 9 */}
        <div className="col-md-6">
            <Field label="PAN" value={viewData.PAN} />
        </div>
        <div className="col-md-6">
            <Field label="TAN" value={viewData.TAN} />
        </div>

        {/* ROW 10 */}
        <div className="col-md-6">
            <Field label="GSTN" value={viewData.GSTN} />
        </div>
        <div className="col-md-6">
            <Field label="CIN" value={viewData.CIN} />
        </div>

        {/* ROW 11 */}
        <div className="col-md-6">
            <Field label="Trademark No" value={viewData.trademarkNo} />
        </div>
        <div className="col-md-6">
            <Field label="Status" value={viewData.status} />
        </div>

    </div>

    {/* FOOTER */}
    <div className="d-flex justify-content-end mt-2">
        <button className="btn btn-secondary" onClick={closeViewModal}>
            <i className="ti ti-cancel me-1"></i> Close
        </button>
    </div>
</div>
            </div>
        </div>
    );
}

function Field({ label, value }) {
    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>
            <input
                className="form-control"
                readOnly
                value={value || "-"}
                style={{
                    backgroundColor: "#f8f9fa",
                    color: "#000",
                    fontWeight: "600",
                    borderColor: "#ced4da",
                }}
            />
        </div>
    );
}
